import React from 'react';

const SummaryCardGrid = ({ children }) => {
    return (
        <div className="mt-2 w-100">
            <div className="row">
                {children.map((child, index) => (
                    <div className="col-12 col-lg-4" key={`summ-${index}`}>
                        {child}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SummaryCardGrid;
